module.exports = __webpack_public_path__ + "public/images/partners/sup-2.07019ea04427a93bce0268ba07708c1f.png";